<i18n locale="en">
{
  "labels": {
    "order": "Order Now"
  }
}
</i18n>

<template>
  <PreviewSheet background="secondary" radius="0">
    <OwnStack class="w-full px-10 py-4">
      <PreviewButtonLegacy color="primary" size="xsmall">
        <PreviewTypographyLegacy
          :text="$t('labels.order')"
          variant="buttonRegular"
          color="white"
        />
      </PreviewButtonLegacy>
    </OwnStack>
  </PreviewSheet>
</template>

<script>
import {
  PreviewSheet,
  PreviewButtonLegacy,
  PreviewTypographyLegacy,
} from '@/lib/builder'

import { OwnStack } from '@/ui'

export default {
  name: 'CTAButtonPreview',
  components: {
    OwnStack,
    PreviewButtonLegacy,
    PreviewSheet,
    PreviewTypographyLegacy,
  },
}
</script>
